import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Select } from 'antd';

// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';
import States from '../../../../config/fiftyStates_copy.json';
import CandianProvinces from '../../../../config/candianProvinces.json';
import Countries from '../../../../config/countries.json';
// import Loading from '../../components/Loading';

const { Option } = Select;

export default class OrgInfo extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    organization: PropTypes.any.isRequired,
    onOrganizationChange: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func.isRequired,
    // email: PropTypes.string.isRequired,
    cage: PropTypes.string.isRequired,
  };

  render() {
    const {
      onSubmit,
      onCancel,
      cage,
      organization,
      onOrganizationChange,
      onCountryChange,
    } = this.props;

    const states = Object.keys(States).map(state => (
      <Option value={state} label={state}>{States[state]}</Option>
    ));

    const candianProvinces = Object.keys(CandianProvinces).map(candianProvince => (
      <Option value={candianProvince} label={candianProvince}>{CandianProvinces[candianProvince]}</Option>
    ));

    const countries = Object.keys(Countries).map(country => (
      <Option value={country} label={country}>{Countries[country]}</Option>
    ));


    return (
      <div>
        <Row
          style={{
            flexWrap: 'nowrap',
          }}
        >
          <Col
            style={{
              marginTop: '16px',
            }}
          >
            {/* <!-- LOADING --> */}
            {/* <!-- CONTENT --> */}
            <div className="nf-registration__content">
              <Row className="nf-row--justify-end" />{' '}
              {/* <!-- USERS GRID --> */}
              <div className="nf-registration__layout">
                {cage && (
                  <div className="nf-registration__input">
                    <p>{msgs.Registration.org.cage}</p>

                    <input
                      className="input-registration"
                      type="text"
                      value={cage ? cage.toUpperCase() : ''}
                      disabled
                    />
                  </div>
                )}
                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.orgName} *</p>

                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    name="name"
                    required
                    type="text"
                    value={organization.name}
                    disabled={cage}
                  />
                </div>
                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.address1} *</p>

                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    name="address1"
                    required
                    type="text"
                    value={organization.address1}
                    disabled={cage}
                  />
                </div>
                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.address2} </p>

                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    type="text"
                    name="address2"
                    value={organization.address2}
                    disabled={cage}
                  />
                </div>

                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.country}  *</p>
                  <div
                    style={{
                      border: '1px solid hsla(0,0%,50%,.596)',
                      borderRadius: '5px',
                    }}
                  >
                    <Select
                      name="cntry"
                      optionLabelProp="label"
                      style={{
                        minWidth: '440px',
                        width: '100%',
                        paddingLeft: '0',
                        paddingRight: '0',
                        fontWeight: '400',
                      }}
                      onChange={onCountryChange}
                      value={organization.cntry}
                      required
                      disabled={cage}
                    >
                      {countries}
                    </Select>
                  </div>
                </div>

                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.state} *</p>
                  <div
                    style={{
                      border: '1px solid hsla(0,0%,50%,.596)',
                      borderRadius: '5px',
                    }}
                  >
                    <Select
                      name="state"
                      optionLabelProp="label"
                      style={{
                        minWidth: '440px',
                        width: '100%',
                        paddingLeft: '0',
                        paddingRight: '0',
                        fontWeight: '400',
                      }}
                      onChange={onOrganizationChange}
                      value={organization.state}
                      required
                      disabled={cage}
                    >
                      {organization.cntry === "USA" && states}
                      {organization.cntry === "CAN" && candianProvinces}
                    </Select>
                  </div>
                </div>

                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.city} *</p>

                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    type="text"
                    name="city"
                    value={organization.city}
                    required
                    disabled={cage}
                  />
                </div>

                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.zipcode} *</p>

                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    type="text"
                    name="zipCode"
                    value={organization.zipCode}
                    required
                    disabled={cage}
                  />
                </div>

                <div className="nf-registration__input">
                  <p>{msgs.Registration.org.address.websiteUrl} *</p>
                  <input
                    className="input-registration"
                    onChange={onOrganizationChange}
                    type="text"
                    name="websiteUrl"
                    value={organization.websiteUrl}
                    required
                    disabled={cage}
                  />
                </div>
                <div className="nf-registration--wrapper">
                  <div className="nf-registration__buttons">
                    <NFButton
                      className="nf-button--gray-border"
                      style={{
                        marginRight: '16px',
                      }}
                      onClick={() => {
                        onCancel();
                      }}
                    >
                      {msgs.Form.backButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      disabled={!organization.name || !organization.address1 || !organization.cntry || !organization.state || !organization.city || !organization.zipCode || !organization.websiteUrl}
                      onClick={() => {
                        onSubmit("orgStep");
                      }}
                    >
                      {msgs.Form.continueButton}
                    </NFButton>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/OrgInfo/OrgInfo.jsx